module.exports = __webpack_public_path__ + "static/media/header.c12732a6.mp3";